import React, { Component, } from "react";
import Header from "../../components/Header/Header";
//Components
import CatalogInputControl from "../../components/CatalogInputControl/CatalogInputControl";
import Footer from "../../components/Footer/Footer";

class Landing extends Component {

  constructor(props) {
    super(props);
    this.state = {
      input: "",
    };
  }

  render() {
    return (
      <div className="results">
        <Header />
        <div className="contents">
          <div className="wrapper">
            <div className="playbook-field-image" />
            <div className="playbook-page-container">
              <div className="landing-title-container">
                <div className="landing-title">
                  <div>Custom Catalog Look Up</div>
                </div>
                <div className="landing-subtitle">
                  <div>Enter your catalog reference # to view your catalog</div>
                </div>
              </div>
              <div className='error'>
                <div className='message'>
                  <CatalogInputControl />
                </div>
                <Footer isVisible={true} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/views/Landing/Landing.js